<template>
  <section
    class="trails-section"
    :style="{
      backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none',
      '--agenda-fontSize': agendaConfig.fontSize,
      '--agenda-textColor': agendaConfig.textColor,
      '--agenda-activeTextColor': agendaConfig.activeTextColor,
      '--agenda-activeBgColor': agendaConfig.activeBgColor,
      '--agenda-bgColor': agendaConfig.bgColor,
      '--agenda-borderColor': agendaConfig.borderColor,
      '--agenda-activeBorderColor': agendaConfig.activeBorderColor,
      '--agenda-borderRadius': agendaConfig.borderRadius,
      '--agenda-margin': agendaConfig.margin,
      '--agenda-padding': agendaConfig.padding,
      '--agenda-trailActiveColor': agendaConfig.trailActiveColor,
      '--agenda-trailInactiveColor': agendaConfig.trailInactiveColor,
      '--agenda-trailTextColor': agendaConfig.trailTextColor,
      '--agenda-trailInactiveTextColor': agendaConfig.trailInactiveTextColor,
    }">
    <Header />
    <div class="trails-container">
      <div class="trails-top-wrapper">
        <button class="trail-item-btn" :class="{ activeTrail: search == trail.trail }" :style="{}" v-for="trail in trailHeaders" :key="trail.trail" @click="search = trail.trail">{{ trail.trail }}</button>
        <button
          class="trail-item-btn"
          :class="{ activeTrail: search === null }"
          @click="search = null"
          v-if="activityData.property.showAllTrailsBtn"
          v-html="activityData.property.textAllTrailsBtn ? activityData.property.textAllTrailsBtn : 'ALL'"></button>
      </div>
      <div class="trails-wrapper" v-for="(trail, i) in trailsComputed" :key="i">
        <hr class="trails-trail-top" :style="{ backgroundColor: 'transparent' }" />
        <div class="section-trail-flex">
          <div class="trail-title-container">
            <p v-if="search == null">{{ trail.name }}</p>
          </div>
          <div class="trails-card-container">
            <div class="activity-card" v-for="(activity, i) in trail.activities" :key="'event' + i">
              <div class="activity-wrapper" :class="{ 'trail-activity-disabled': !activity.enableAction }">
                <div class="trail-line" :style="{ backgroundColor: trail.color }">&nbsp;</div>
                <div class="activity-img">
                  <img :src="activity.image" />
                </div>
                <!-- <div class="activity-time">{{activity.time}}</div> -->
                <div class="activity-name" v-html="activity.name"></div>
                <div class="activity-description" v-html="activity.description"></div>
                <!-- <div class="activity-onair" v-if="activity.onair"></div> -->
                <a class="activity-action-btn" :style="{ backgroundColor: trail.color }" @click.prevent="handleActionClick(activity)" v-if="activity.enableAction">{{ activity.action }}</a>
                <a class="activity-calendar-btn" @click.prevent="openDialog(activity)" v-if="$store.state.template.accessConfig.enablePersonalAgenda && !activity.enableAction && checkIfUserHasEvent(activity)">
                  Adicionar ao calendário
                  <i class="fas fa-calendar-check" style="margin-left: 8px"></i>
                </a>
                <router-link class="activity-calendar-btn" :to="{ name: 'UserProfile' }" v-if="$store.state.template.accessConfig.enablePersonalAgenda && !activity.enableAction && !checkIfUserHasEvent(activity)">
                  Calendário
                  <i class="fas fa-calendar-check" style="margin-left: 8px"></i>
                </router-link>
                <div class="activity-action-btn-placeholder" v-if="!$store.state.template.accessConfig.enablePersonalAgenda && !activity.enableAction"></div>
              </div>
              <!-- <div class="sneakpeek-container" v-if="activity.item.property.srcVideo">
                <div class="trail-extension" :style="{backgroundColor: trail.color}">&nbsp;</div>
                <iframe style="margin-left:auto" :src="activity.item.property.srcVideo" frameborder="0"></iframe>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <div class="user-schedule-dialog-box trails-event-dialog-box" v-if="showDialog">
      <div class="event-card-toolbar-container" :class="selectedEvent.class">
        <i title="Fechar" class="event-card-toolbar-item fas fa-times" @click="showDialog = false"></i>
      </div>
      <div class="event-card-row">
        <i class="far fa-clock" style="margin-right: 8px"></i>
        <span>{{ dateFormatHandler(selectedEvent.start) }} - {{ dateFormatHandler(selectedEvent.end) }}</span>
      </div>
      <div class="event-card-row">
        <i class="far fa-calendar-check"></i>
        <input class="event-card-input" type="text" disabled v-model="selectedEvent.title" />
      </div>
      <div class="event-card-row">
        <i class="fas fa-bars"></i>
        <input class="event-card-input" disabled v-model="selectedEvent.description" />
      </div>
      <div class="event-card-row" style="background: transparent">
        <button class="button" style="margin-left: auto" @click="showDialog = false">Cancelar</button>
        <button class="button" style="margin-left: 20px" @click="saveSchedule">Adicionar</button>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';
import * as dayjs from 'dayjs';

export default {
  name: 'Trails',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      dayjs: null,
      showLegal: true,
      update: 0,
      activityData: {
        activity: '',
        images: {},
        speaker: [],
        interactivities: {
          chat: false,
          qa: false,
          quiz: false,
          poll: false,
        },
        property: {
          config: '',
          category: '',
        },
      },
      title: '',
      search: null,
      trails: [],
      trailHeaders: [],
      canCallApi: true,
      agendaConfig: {},
      userSchedule: [],
      selectedEvent: {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: null,
        start_date: null,
        finish_date: null,
        title: 'NEW EVENT',
        description: 'description',
        notes: '',
        class: 'default',
        config: JSON.stringify({ class: 'typeA' }),
        links: [],
        guests: JSON.stringify([{ user_id: 'ee743390-7a95-11ea-9ca4-6f54e6b90ced', name: '' }]),
        organizer: this.$store.state.user.id,
        status: 'Aguardando aceite',
        confirm: JSON.stringify(false),
        public: JSON.stringify(true),
      },
      isEditing: true,
      showDialog: false,
    };
  },
  computed: {
    trailsComputed() {
      // this.trails.sort((a, b) => (a.tags > b.tags ? 1 : -1));
      if (this.search) return this.trails.filter((trail) => trail.name == this.search);
      else return this.trails;
    },
  },
  methods: {
    loadTrails() {
      let tempTrails = [];
      api
        .get(`event/${this.$store.state.eventId}/foyer`)
        .then((response) => {
          // console.log('Response =', response.data);

          function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
          }

          const trail_all = response.data.map((act) => {
            return act.trail_id;
          });
          //console.log('All =',trail_all)
          const unique = trail_all.filter(onlyUnique);
          //console.log('Unique =',unique); // ['a', 1, 2, '1']
          unique.map((trail_id) => {
            // console.log('TRAIL-ID =', trail_id);
            if (trail_id) {
              const activities = response.data.filter((act) => {
                try {
                  const ret = act.trail_id == trail_id;
                  return ret;
                } catch (err) {
                  console.error(err);
                  return false;
                }
              });
              let act = [];
              activities.map((act_item) => {
                // console.log('ACT ITEM =', act_item);
                try {
                  act_item.images = act_item.images ? JSON.parse(act_item.images) : { poster: '', bg: '', curtain: '' };
                  act_item.property = JSON.parse(act_item.property);
                } catch (err) {}
                act.push({
                  item: act_item,
                  name: act_item.description_short,
                  description: act_item.description,
                  time: act_item.onair ? act_item.property.nowText : act_item.property.now ? act_item.property.nowText : act_item.property.time,
                  image: act_item.images.poster ? act_item.images.poster : null,
                  action: act_item.property.action,
                  url: act_item.property.meetLink ? act_item.property.meetLink : null,
                  enableAction: act_item.onair || act_item.property.now,
                });
              });
              // console.log('ACT =', act);
              const obj = {
                name: activities[0].trail,
                subName: activities[0].trail_description,
                color: activities[0].color,
                activities: act,
              };
              // console.log('OBJ =', obj);
              tempTrails.push(obj);
              // this.trails.push(obj);
            }
          });

          this.trails = tempTrails;
          this.trails = this.trails.filter((trail) => trail.subName == this.activityData.property.group);

          this.getTrailHeaders();
          // console.log('activity', this.activityData);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          //console.log(response);

          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;

          response.data.interactivity.forEach((item) => {
            this.activityData.interactivities[item.interactivity] = item.enable;
          });

          this.title = this.activityData.activity;
          this.loadTrails();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getTrailHeaders() {
      api
        .get(`event/${this.$store.state.eventId}/trail`)
        .then((response) => {
          // console.log('trails', response);
          this.trailHeaders = response.data;
          this.trailHeaders = this.trailHeaders.filter((trail) => trail.description == this.activityData.property.group);

          this.trails = this.trails.map((trail) => {
            this.trailHeaders.map((trailHeader) => {
              trail.tags = parseInt(trail.tags);
              if (trail.name == trailHeader.trail) {
                trail = { ...trail, ...trailHeader };
              }
            });
            return trail;
          });
          this.trailHeaders.sort((a, b) => (a.tags > b.tags ? 1 : -1));
          this.trails.sort((a, b) => (a.tags > b.tags ? 1 : -1));
        })
        .catch((err) => {
          console.error(err);
        });
    },
    apiGetUserSchedule() {
      // console.log('getSchedule');
      let userQuery = this.user_id ? `?user_id=${this.user_id}` : '';
      api
        .get(`event/${this.$store.state.eventId}/schedule${userQuery}`)
        .then((response) => {
          this.userSchedule = response.data;
          // console.log('apiGetUserSchedule:', response.data);
        })
        .catch((err) => console.error(err));
    },
    checkIfUserHasEvent(activity) {
      let ids = this.userSchedule.map((item) => item.activity_id);
      // console.log('ids', ids);
      return !ids.includes(activity.item.activity_id ? activity.item.activity_id : null);
    },
    handleActionClick(activity) {
      // console.log('ACTION CLICKED' + JSON.stringify(activity));

      if (this.canCallApi) {
        // this.loadTrails();

        if (!activity.url && !activity.item.property.meetlink) {
          this.$router.push({ name: this.$RouteParser.getName(activity.item.activity_type_id), params: { stream: activity.item.activity_id } });
        } else if (activity.url && activity.url.startsWith('{')) {
          let route = JSON.parse(activity.url);
          this.$router.push(route);
        } else if (activity.url && !activity.url.startsWith('{')) {
          window.open(activity.url);
        }
        this.canCallApi = false;
        setTimeout(() => {
          this.canCallApi = true;
        }, 1000);
      }
    },
    openDialog(activity) {
      this.showDialog = true;
      this.selectedEvent = { ...this.selectedEvent, ...activity };
      this.selectedEvent.activity_id = this.selectedEvent.item.activity_id;
      this.selectedEvent.title = this.selectedEvent.name;
      this.selectedEvent.start_date = new Date(this.selectedEvent.item.date_start);
      this.selectedEvent.finish_date = new Date(this.selectedEvent.item.date_finish);
      this.selectedEvent.start = new Date(this.selectedEvent.item.date_start);
      this.selectedEvent.end = new Date(this.selectedEvent.item.date_finish);
      this.selectedEvent.links = [{ url: this.selectedEvent.url }];
      this.selectedEvent.draggable = false;
      this.selectedEvent.resizable = false;
    },
    saveSchedule() {
      let payload = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: this.selectedEvent.activity_id,
        start_date: this.selectedEvent.item.date_start,
        finish_date: this.selectedEvent.item.date_finish,
        title: this.selectedEvent.name,
        description: 'description',
        notes: '',
        config: JSON.stringify({ class: 'default', draggable: this.selectedEvent.draggable, resizable: this.selectedEvent.resizable }),
        links: JSON.stringify(this.selectedEvent.links),
        guests: JSON.stringify([]),
        organizer: this.$store.state.user.id,
        status: 'Confirmado',
        confirm: JSON.stringify(false),
        public: JSON.stringify(false),
      };
      // console.log('payload:', { payload });

      api
        .post(`event/${this.$store.state.eventId}/schedule/`, payload)
        .then((response) => {
          // console.log('apiPostSchedule:', { response });
          this.showDialog = false;
          setTimeout(() => {
            alert('Compromisso incluído');
            this.$router.go();
          }, 100);
        })
        .catch((err) => {
          this.showDialog = false;
          console.error(err);
        });
    },
    dateFormatHandler(date) {
      // console.log(start);
      return this.dayjs(date).format('DD/MMMM/YYYY, ddd, HH:mm');
    },
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },
  beforeMount() {
    this.dayjs = dayjs;
    this.agendaConfig = this.$store.state.template.agendaConfig;
    this.loadActivity();
    this.apiGetUserSchedule();
  },
  mounted() {
    this.update = setInterval(() => {
      this.loadTrails();
      this.apiGetUserSchedule();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.update);
  },
};
</script>

<style lang="scss">
.trails-section {
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  min-height: 100dvh;
  width: 100vw;
}
.trails-container {
  position: relative;
  width: 100vw;
  min-height: 97vh;
  padding: 2%;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include media('<=phone') {
    padding-top: 50px;
  }
}
.trails-top-wrapper {
  // background: red;
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  padding: 10px 14%;
  @include media('<=phone-plus') {
    padding: 1%;
  }
}
.trail-item-btn {
  background: var(--agenda-bgColor);
  font-size: var(--agenda-fontSize);
  font-weight: bolder;
  color: var(--agenda-textColor);
  border: 1px solid var(--agenda-borderColor);
  border-radius: var(--agenda-borderRadius);
  margin: var(--agenda-margin);
  padding: var(--agenda-padding);
  height: auto;
  // flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.activeTrail {
  background: var(--agenda-activeBgColor);
  color: var(--agenda-activeTextColor);
  border: 1px solid var(--agenda-activeBorderColor);
}
.trails-wrapper {
  position: relative;
  height: auto;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
}

.trails-trail-top {
  background-color: var(--main-color);
  color: #ffffff;
  height: 1vh;
  width: 100%;
  border-width: 0;
  margin: 14px 0;
}
.section-trail-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 1080px;
  padding: 0 40px;
  @include media('<=tablet') {
    padding: 20px;
    width: 100%;
  }
}

.trail-title-container {
  width: 100%;
  font-weight: bold;
  font-size: 2.3rem;
  margin-bottom: 6px;
  color: var(--agenda-textColor);

  p {
    overflow-x: hidden;
  }
  @include media('<=tablet') {
    width: 100%;
    padding-left: 1%;
  }
  @include media('<=phone') {
    font-size: 10vw;
  }
}

.trails-card-container {
  width: 100%;
  max-height: 88vh;
  overflow-y: auto;
  margin-right: 0vw;
  @include media('<=tablet') {
    width: 100%;
  }
}
.activity-wrapper {
  background: var(--agenda-trailActiveColor);
  color: var(--agenda-trailTextColor);
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding-right: 18px;
  @include media('<=tablet') {
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 10px 0px;
  }
}
.activity-card {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 7px;
  @include media('<=tablet') {
    // width: 100vw;
  }
}
.trail-line {
  position: absolute;
  top: 0;
  width: 5px;
  height: 100%;
}
.trail-extension {
  position: relative;
  height: 100%;
  width: 5px;
}
.activity-img {
  // align-self: flex-start;
  padding: 10px;
  margin: 0 10px;
  img {
    object-fit: cover;
    height: 8vh;
    width: 8vh;
  }
  @include media('<=phone') {
    padding-left: 1.5%;
  }
}

.activity-name {
  min-width: 25%;
  font-size: 1.33rem;
  font-weight: bolder;
  @include media('<=phone-plus') {
    flex-grow: 1;
  }
}
.activity-time {
  font-weight: 300;
}
.activity-description {
  // flex-grow: 1;
  width: 40%;
  font-size: 1.13rem;
  font-weight: 300;
  margin: 2%;
  margin-left: 3.3%;
  display: flex;
  justify-content: flex-start;
  @include media('<=phone-plus') {
    justify-content: center;
    width: 100%;
    margin: 16px;
  }
}
.activity-action-btn,
.activity-calendar-btn {
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  outline: none;
  border: none;
  position: relative;
  max-width: 26%;
  flex-grow: 1;
  padding: 10px 20px;
  // font-size: 1.1rem;
  font-weight: bold;
  // text-align: center;
  color: var(--button-text);
  display: flex;
  align-items: center;
  justify-content: center;
  // background: var(--agenda-activeTextColor);
  @include media('<=tablet') {
    margin: 20px 20px;
    max-width: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  @include media('<=phone') {
    margin: 20px 5.6%;
  }
}
.activity-calendar-btn {
  color: #bbb;
  justify-content: flex-end;
  padding: 10px 0px;
  transition: all 1s ease;
  max-width: 18%;
  text-align: center;
  &:hover {
    padding-right: 2%;
    color: var(--button-text);
    background: var(--button-hover);
  }

  @include media('<=tablet') {
    justify-content: center;
    max-width: 100%;
  }
}
.activity-action-btn-placeholder {
  width: 26%;
}
.activity-onair {
  // position: absolute;
  // top: 0;
  // right: 0;
  width: 20px;
  height: 20px;
  background: green;
  border-radius: 50%;
  // margin-left: auto;
}
.trail-activity-disabled {
  background: var(--agenda-trailInactiveColor) !important;
  color: var(--agenda-trailInactiveTextColor);
}
.sneakpeek-container {
  display: flex;
  width: 100%;
  height: 0;
  background: var(--agenda-trailActiveColor);
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.2s ease;
  overflow: hidden;
  iframe {
    padding: 10px;
  }
}
.activity-card:hover > .sneakpeek-container {
  display: flex;
  height: auto;
  transform: scaleY(1);
}

.trails-event-dialog-box {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
}
</style>
